import React, { useState, useEffect, useRef } from 'react';
import { Calendar } from '@progress/kendo-react-dateinputs';
import styled from 'styled-components';
const CustomCalendar = props => {
  const { onChange, max, min } = props;
  const [showCalendar, setShowCalendar] = useState(true);
  const calendarRef = useRef<HTMLDivElement>(null);
  const handleDateChange = event => {
    onChange({
      value: event.target.value,
    });
    setShowCalendar(false);
  };
  const handleClickOutside = event => {
    if (calendarRef.current && !calendarRef.current.contains(event.target)) {
      setShowCalendar(false);
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return (
    <Wrapper ref={calendarRef}>
      {' '}
      {showCalendar && (
        <Calendar
          className="custom-datepicker"
          value={props.value}
          onChange={handleDateChange}
          navigation={false}
          max={max}
          min={min}
        />
      )}{' '}
    </Wrapper>
  );
};
const Wrapper = styled.div`
  .k-calendar-infinite .k-calendar-view {
    height: 316px !important;
  }
  .custom-datepicker {
    background-color: ${p => p.theme.white} !important;
    border-radius: 4px;
    font-family: 'Open Sans';
    .k-content {
      background: ${p => p.theme.white} !important;
    }
  }
  .k-calendar-infinite .k-calendar-view::after {
    box-shadow: 0 0 38px 19px ${p => p.theme.calendarPopupInfinitBoxShadowClr} !important;
  }
  .k-button {
    color: ${p => p.theme.calendarDaysClr};
    font-family: 'Open Sans';
    &:hover {
      background: ${p => p.theme.calendarDaysClrHvr} !important;
    }
  }
  .k-calendar .k-calendar-th {
    color: ${p => p.theme.calendarDaysHeaderClr};
  }
  .k-calendar .k-link {
    color: ${p => p.theme.calendarDaysClr};
    font-family: 'Open Sans';
    &:hover {
      background: ${p => p.theme.calendarDaysClrHvr} !important;
    }
  }
  .k-calendar .k-calendar-td.k-selected .k-link {
    &:hover {
      color: ${p => p.theme.calendarActiveClr} !important;
    }
  }
  .k-calendar-nav-today {
    color: ${p => p.theme.calendarActiveClr};
  }
`;
export default CustomCalendar;
